document.addEventListener("DOMContentLoaded", function () {
    console.log('sdkfjskfjslkfjl')
      var total_price = 0.00;
      var original_price = 0.00;
      getTotalPrice();
  
      var targetNode = document.body;
      var config = { childList: true, subtree: true, autocomplete: false };
  
      var click_state = true;
      var flag = true;
  
      setInterval(() => {
          if (flag == true) {
              updateAllDate();
          }
      }, 200)
  
      var callback = function (mutationsList, observer) {
          for (var mutation of mutationsList) {
              if (mutation.type === 'childList') {
                if(document.querySelector('.Drawer')){
                  if (document.querySelector('#sidebar-cart .Drawer__Content')) {
                      if (document.querySelector('#teeFormActions #teeAtcButton') && click_state == true) {
                          click_state = false;
  
                          var button = document.querySelector('#teeFormActions #teeAtcButton');
  
                          button.addEventListener('click', function () {
                              updateAllDate();
                              const lo = setInterval(() => {
                                  updateAllDate();
                              }, 50)
                              const interval = setInterval(() => {
                                  flag = false;
                                  if (document.querySelector('#sidebar-cart').getAttribute('aria-hidden') == 'false') {
                                      setTimeout(() => {
                                          clearInterval(lo)
                                          update('remove');
                                      }, 500)
                                      clearInterval(interval);
                                  }
                              }, 500)
                          })
                      }
  
                      if (document.querySelectorAll('.QuantitySelector__Button')) {
                          var actions = document.querySelectorAll('.QuantitySelector__Button');
  
                          actions.forEach((item, index) => {
                              item.addEventListener('click', function () {
                                  updateAllDate();
                                  const lo = setInterval(() => {
                                      updateAllDate();
                                  }, 50)
                                  const interval = setInterval(() => {
                                      flag = false;
                                      if (document.querySelector('#sidebar-cart').getAttribute('aria-hidden') == 'false') {
                                          setTimeout(() => {
                                              clearInterval(lo)
                                              if (item.classList.contains('decrease-btn')) {
                                                  updateAllDate();
                                                  if (total_price - parseFloat(item.parentElement.parentElement.parentElement.parentElement.querySelector('.CartItem__Price').textContent.split('€')[0]) < 125) {
                                                      update('remove');
                                                  }
                                                  else {
                                                      getTotalPrice();
                                                      setTimeout(()=>{
                                                        updateAllDate();
                                                      }, 1000)
                                                  }
                                              }
                                              else if (item.classList.contains('increase-btn')) {
                                                  updateAllDate();
                                                  if (total_price < 125) {
                                                      update('add');
                                                  }
                                                  else {
                                                      getTotalPrice();
                                                      setTimeout(()=>{
                                                        updateAllDate();
                                                      }, 1000)
                                                  }
                                              }
                                          }, 500)
                                          clearInterval(interval);
                                      }
                                  }, 500)
                              })
                          })
                      }
                  }
                }
              }
          }
      };
  
  
  
      function update(states) {
          setTimeout(() => {
              var AnnouncementBars = document.querySelector('.AnnouncementBar');
              var Cartdrawers;
              var modals;
  
              if (document.querySelector('#sidebar-cart .Drawer__Content')) {
                  Cartdrawers = document.querySelector('#sidebar-cart .Drawer__Content .discount-wrapper')
                  modals = document.querySelector('#sidebar-cart .cart-overlay')
              }
  
              getTotalPrice();
  
              if (Cartdrawers && modals) {
                  ChangeClassName(modals.querySelector('.progress-bar-element-value'), 'disable-transition', 'add');
                  DrawProgressBarDots();
                  updateProgress();
  
  
                  ChangeClassName(modals, 'show', 'add');
                  ChangeClassName(modals.querySelector('.animation-modal'), 'animation-active', 'add');
  
                  const lo = setInterval(() => {
                      DrawProgressBarDots();
                      updateProgressBarDots(modals, original_price);
                      updateProgressBarValue(modals, original_price);
                      ChangeActive(modals, original_price);
                      if (states == 'remove') {
                          activeDots(modals, false);
                      }
                      else if (states == 'add') {
                          activeDots(modals, false);
                      }
                  }, 50)
  
                  setTimeout(() => {
                      clearInterval(lo)
                      setTimeout(() => {
                          ChangeClassName(modals.querySelector('.progress-bar-element-value'), 'disable-transition', 'remove');
                          setTimeout(() => {
                              updateProgressBarDots(modals, total_price);
                              updateProgressBarValue(modals, total_price);
                              setTimeout(() => {
                                  ActivePrice(modals, total_price);
                              }, 300)
                              if (states == 'remove') {
                                  activeDots(modals, false);
                              }
                              else if (states == 'add') {
                                  activeDots(modals, true);
                              }
                          }, 300)
                      }, 200)
                  }, 1000)
  
                  setTimeout(() => {
                      updateProgress()
                      updateModalProgress();
                      DrawProgressBarDots();
                      ActivePrice(AnnouncementBars, total_price);
                      ActivePrice(Cartdrawers, total_price);
                      ActivePrice(modals, total_price);
                      ChangeClassName(modals, 'animation-active', 'remove')
                      ChangeClassName(modals, 'show', 'remove')
                      setTimeout(() => {
                          flag = true;
                      }, 500)
                  }, 4000);
              }
              else {
                  setTimeout(() => {
                      updateProgressBarDots(AnnouncementBars, total_price);
                      updateProgressBarValue(AnnouncementBars, total_price);
                      ActivePrice(AnnouncementBars, total_price);
                      original_price = 0;
                      total_price = 0;
                  }, 1500)
              }
  
  
              function updateProgress() {
                  updateProgressBarDots(Cartdrawers, total_price);
                  updateProgressBarDots(AnnouncementBars, total_price);
                  updateProgressBarValue(Cartdrawers, total_price);
                  updateProgressBarValue(AnnouncementBars, total_price);
              }
  
              function DrawProgressBarDots() {
                  DrawDots(Cartdrawers);
                  DrawDots(modals);
              }
  
              function updateModalProgress() {
                  updateProgressBarDots(modals, total_price);
                  updateProgressBarValue(modals, total_price);
                  activeDots(modals, true);
              }
          }, 1000)
      }
  
      function updateAllDate() {
          var AnnouncementBar = document.querySelector('.AnnouncementBar');
          var Cartdrawer;
          var modal;
  
          if (document.querySelector('#sidebar-cart .Drawer__Content .discount-wrapper')) {
              Cartdrawer = document.querySelector('#sidebar-cart .Drawer__Content .discount-wrapper');
              modal = document.querySelector('#sidebar-cart .cart-overlay');
          }
          if (document.querySelector('#sidebar-cart .Drawer__Content .discount-wrapper')) {
              updateProgressAnnouncementBar();
              updateProgressCartDrawer();
              DrawProgressBarDots();
              updateModalProgress();
              ActivePrice(AnnouncementBar, total_price);
              ActivePrice(Cartdrawer, total_price);
              ActivePrice(modal, total_price);
          }
          else {
              DrawDots(AnnouncementBar);
              updateProgressAnnouncementBar();
              ActivePrice(AnnouncementBar, total_price);
          }
  
          function updateProgressAnnouncementBar() {
              updateProgressBarDots(AnnouncementBar, total_price);
              updateProgressBarValue(AnnouncementBar, total_price);
          }
  
          function updateProgressCartDrawer() {
              updateProgressBarDots(Cartdrawer, total_price);
              updateProgressBarValue(Cartdrawer, total_price);
          }
  
          function DrawProgressBarDots() {
              DrawDots(AnnouncementBar);
              DrawDots(Cartdrawer);
              DrawDots(modal);
          }
  
          function updateModalProgress() {
              updateProgressBarDots(modal, total_price);
              updateProgressBarValue(modal, total_price);
              activeDots(modal, true);
          }
      }
  
      function getTotalPrice() {
          original_price = total_price;
          fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                  let totalPrice = 0;
  
                  cart.items.forEach(item => {
                      totalPrice += item.price * item.quantity;
                    console.log('sdfkjskf',item.final_price, item.line_price)
                  });
  
                  let totalPriceInDollars = (totalPrice / 100).toFixed(2);
                  total_price = totalPriceInDollars;
              })
              .catch(error => {
                  console.error("Error fetching the cart data:", error);
              });
      }
  
  
      var observer = new MutationObserver(callback);
      if (targetNode) {
          observer.observe(targetNode, config);
      } else {
          console.error('targetNode not found. Make sure "predictive-search" exists in the DOM.');
      }
  })
  
  function ActivePrice(element, value) {
      var prices = element.querySelectorAll('.product-percent .percentageWrapper');
      prices.forEach((item, index) => {
          if(item.querySelector('svg')){
            ChangeClassName(item.querySelector('svg'), 'hidden', 'add');
          }
      })
  
      prices.forEach((item, index) => {
          if (parseFloat(item.getAttribute('price')) <= value) {
            if(item.querySelector('svg')){
              ChangeClassName(item.querySelector('svg'), 'hidden', 'remove');
            }
          }
      })
  }
  
  function activeDots(element, states) {
      var array = [];
      var animationFrame;
      element.querySelectorAll('.progress-bar-element-dot').forEach((item, index) => {
          array.push(parseFloat(item.style.left.split('px')[0]));
      })
  
      function lol() {
          const computedStyle = window.getComputedStyle(element.querySelector('.progress-bar-element-value'));
          const left = parseFloat(computedStyle.left);
          for (let i = 0; i < array.length; i++) {
              if (states == true) {
                  if (left >= array[i]) {
                      ChangeClassName(element.querySelectorAll('.progress-bar-element-dot')[i], 'active', 'add')
                  }
              }
              else {
                  if (left < array[i]) {
                      ChangeClassName(element.querySelectorAll('.progress-bar-element-dot')[i], 'active', 'remove')
                  }
              }
          }
          animationFrame = requestAnimationFrame(lol)
      }
      animationFrame = requestAnimationFrame(lol)
      setTimeout(() => {
          cancelAnimationFrame(animationFrame)
      }, 4000)
  }
  
  function DrawDots(element) {
      const width = element.querySelector('progress').offsetWidth;
  
      element.querySelectorAll('.progress-bar-element-dot').forEach((item, index) => {
          item.style.left = `${(width / element.querySelectorAll('.progress-bar-element-dot').length) * (index + 1)}px`;
      })
  }
  
  function updateProgressBarDots(element, value) {
      var price = value;
      if(value >= 50){
          price = (value - 50) * 2 + 50;
      }
      else{
        price = value
      }
      element.querySelector('progress').value = price;
  
      if (element != document.querySelector('#sidebar-cart .cart-overlay')) {
          ChangeActive(element, value);
      }
  
  }
  
  function ChangeActive(element, value) {
      element.querySelectorAll('.progress-bar-element-dot').forEach((item, index) => {
          ChangeClassName(item, 'active', 'remove')
      })
  
      element.querySelectorAll('.progress-bar-element-dot').forEach((item, index) => {
          if (value >= parseFloat(item.getAttribute('price'))) {
              ChangeClassName(item, 'active', 'add')
          }
          else {
              ChangeClassName(item, 'active', 'remove')
          }
      })
  }
  
  function updateProgressBarValue(element, value) {
        var v = value;
      if(v <= 50){
        var init_left = 0;
        var in_left = 0;
        element.querySelectorAll('.progress-bar-element-dot').forEach((item, index)=>{
            if(item.getAttribute('price') == 50){
                init_left = window.getComputedStyle(item);
                in_left = parseFloat(init_left.left)
            }
        })
        const BarWidth = element.querySelector('.progress-bar-element').offsetWidth;
        var left = (Math.min(Math.max(v, 0), 200) / 200) * BarWidth - 32 * (v / 200);
        element.querySelector('.progress-bar-element .progress-bar-element-value').style.left = `${left}px`;
      }
      else{
        var num = Math.floor((v - 50) / 25);
        var s_num = v % 25;
        var add = 0;
        if(v > 120){
          add = 6;
        }
        else if(v > 100){
          add = 5;
        }
        else if(v > 75){
          add = 4;
        }
        else if(v > 50){
          add = 3;
        }
        else{
          add = 1;
        }
        var init_left = 0;
        var in_left = 0;
        element.querySelectorAll('.progress-bar-element-dot').forEach((item, index)=>{
            if(item.getAttribute('price') == 50){
                init_left = window.getComputedStyle(item);
                in_left = parseFloat(init_left.left)
            }
        })
        
        const BarWidth = element.querySelector('.progress-bar-element').offsetWidth;
        var h_left = (50 / 200) * BarWidth - 32 * (50 / 200)
        var s_left = (Math.min(Math.max(s_num, 0), 200) / 200) * BarWidth - 32 * (s_num / 200);
        var left = h_left + h_left * num + s_left * 2 + add;
        element.querySelector('.progress-bar-element .progress-bar-element-value').style.left = `${left}px`;
      }
  }
  
  function ChangeClassName(element, className, state) {
      if (state == 'add') {
          element.classList.add(className)
      }
      else if ('remove') {
          element.classList.remove(className)
      }
  }
  
  